export default "__VITE_ASSET__401688d1__"